import { z } from "zod";
import { auditActorFields } from "../common/audit.js";
import { booleanQueryParam } from "../common/query-params.js";
export const shelfInfo = z.object({
    id: z.string().uuid(),
    fixtureId: z.string().uuid(),
    storeId: z.string().uuid(),
    /** Top-to-bottom position: 1 is the top shelf. Height is measured separately. */
    level: z.number().int().min(1),
    label: z.string().nullable(),
    heightFromFloorMm: z.number().int().nullable(),
    widthMm: z.number().int().nullable(),
    depthMm: z.number().int().nullable(),
    visibilityZone: z.string().nullable(),
    isActive: z.boolean(),
    metadata: z.record(z.unknown()),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    ...auditActorFields,
});
export const createShelfRequest = z.object({
    /** Top-to-bottom position: 1 is the top shelf. Height is measured separately. */
    level: z.number().int().min(1),
    label: z.string().min(1).max(255).nullish(),
    heightFromFloorMm: z.number().int().min(0).nullish(),
    widthMm: z.number().int().positive().nullish(),
    depthMm: z.number().int().positive().nullish(),
    visibilityZone: z.string().max(64).nullish(),
    isActive: z.boolean().default(true),
    metadata: z.record(z.unknown()).default({}),
});
export const updateShelfRequest = createShelfRequest.partial().refine((v) => Object.keys(v).length > 0, { message: "At least one field required" });
export const shelvesListResponse = z.object({ items: z.array(shelfInfo) });
// Standalone shelves listing (not nested under a fixture). At least one of
// storeId / fixtureId should be provided to scope the result.
export const listShelvesQuery = z.object({
    storeId: z.string().uuid().optional(),
    fixtureId: z.string().uuid().optional(),
    isActive: booleanQueryParam.optional(),
});
//# sourceMappingURL=shelves.schemas.js.map